import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingUp, TrendingDown, Minus, MapPin, PlusCircle } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function DetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-756">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-757">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-758">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-759">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-760">
            <div data-id="element-761">
              <p className="font-semibold text-gray-900" data-id="element-762">SOS State</p>
              <p className="text-gray-600" data-id="element-763">PA</p>
            </div>
            <div data-id="element-764">
              <p className="font-semibold text-gray-900" data-id="element-765">Founded Date</p>
              <p className="text-gray-600" data-id="element-766">1949</p>
            </div>
            <div data-id="element-767">
              <p className="font-semibold text-gray-900" data-id="element-768">SOS Number</p>
              <p className="text-gray-600" data-id="element-769">8675309</p>
            </div>
            <div data-id="element-770">
              <p className="font-semibold text-gray-900" data-id="element-771">Type</p>
              <p className="text-gray-600" data-id="element-772">S-Corporation</p>
            </div>
            <div data-id="element-773">
              <p className="font-semibold text-gray-900" data-id="element-774">TIN Number</p>
              <p className="text-gray-600" data-id="element-775">23-1984726</p>
            </div>
            <div data-id="element-776">
              <p className="font-semibold text-gray-900" data-id="element-777">DBAs</p>
              <p className="text-gray-600" data-id="element-778">DUNDER MIFFLIN</p>
            </div>
            <div data-id="element-779">
              <p className="font-semibold text-gray-900" data-id="element-780">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-781">Domestic</p>
            </div>
            <div data-id="element-782">
              <p className="font-semibold text-gray-900" data-id="element-783">Entity Type</p>
              <p className="text-gray-600" data-id="element-784">Private Subsidiary</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-785">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-786">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-787">
            <div data-id="element-788">
              <p className="font-semibold text-gray-900" data-id="element-789">SIC</p>
              <p className="text-gray-600" data-id="element-790">5112 - PAPER & OFFICE SUPPLIES</p>
            </div>
            <div data-id="element-791">
              <p className="font-semibold text-gray-900" data-id="element-792">Ticker</p>
              <p className="text-gray-600" data-id="element-793">--</p>
            </div>
            <div data-id="element-794">
              <p className="font-semibold text-gray-900" data-id="element-795">NAICS</p>
              <p className="text-gray-600" data-id="element-796">
                424120 - STATIONERY AND OFFICE SUPPLIES
              </p>
            </div>
            <div data-id="element-797">
              <p className="font-semibold text-gray-900" data-id="element-798">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-799">~$48 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-800">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-801">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-802">
              Dunder Mifflin Inc. provides paper and office supplies to small
              businesses. With a mid-size market focus, we pride ourselves on
              customer service that big box stores can't match. "Limitless paper
              in a paperless world."
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-803">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-804">
          <div className="flex justify-between items-start mb-2" data-id="element-805">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-806">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-807" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-808">
            <p data-id="element-809">1725 SLOUGH AVENUE, SUITE 200</p>
            <p data-id="element-810">SCRANTON, PA 18503, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-811">
            <img src="https://cdn.magicpatterns.com/uploads/wvsUfBV1167d45Ehi9LHfe/scrantonbusinesspark2.jpg" alt="Dunder Mifflin Office - Scranton Business Park" className="w-full h-full object-contain bg-gray-50" data-id="element-812" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-813">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-814">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-815">Legal Filings (3)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-816">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-817">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-818" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-819" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-820" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-821" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-822">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-823">
              <div className="flex items-center gap-4" data-id="element-824">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-825">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-826" />
                </div>
                <div className="text-left" data-id="element-827">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-828">
                    <h4 className="font-bold text-gray-900" data-id="element-829">
                      LACKAWANNA COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Released" data-id="element-830"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-831">
                    STATE TAX LIEN • RELEASED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-832">
                <p className="font-medium text-gray-900" data-id="element-833">4/25/2016</p>
                <p className="text-sm text-gray-500" data-id="element-834">$1,118</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-835">
              <div className="flex items-center gap-4" data-id="element-836">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-837">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-838" />
                </div>
                <div className="text-left" data-id="element-839">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-840">
                    <h4 className="font-bold text-gray-900" data-id="element-841">
                      DE LAGE LANDEN FINANCIAL SERVICES
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-blue-500" title="Active" data-id="element-842"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-843">
                    UCC FILING • EQUIPMENT LEASE (COPIERS)
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-844">
                <p className="font-medium text-gray-900" data-id="element-845">2/14/2023</p>
                <p className="text-sm text-gray-500" data-id="element-846">Active</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-847">
              <div className="flex items-center gap-4" data-id="element-848">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-849">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-850" />
                </div>
                <div className="text-left" data-id="element-851">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-852">
                    <h4 className="font-bold text-gray-900" data-id="element-853">
                      LEASE DISPUTE LAWSUIT
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Settled" data-id="element-854"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-855">
                    CIVIL LAWSUIT • LEASE DISPUTE • SETTLED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-856">
                <p className="font-medium text-gray-900" data-id="element-857">6/10/2019</p>
                <p className="text-sm text-gray-500" data-id="element-858">Settled</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-859">
        <div className="p-5 border-b border-gray-200" data-id="element-860">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-861">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-862">
          <table className="w-full text-sm text-left" data-id="element-863">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-864">
              <tr data-id="element-865">
                <th className="px-5 py-3 font-medium" data-id="element-866">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-867">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-868">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-869">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-870">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-871">
                  Mar 15, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-872">
                  Scranton Branch Reports Record Breaking Sales Quarter, Led by
                  Top Salesman Dwight Schrute
                </td>
                <td className="px-5 py-4" data-id="element-873">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-874">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-875" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-876">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-877">
                  Feb 28, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-878">
                  Regional Manager Hosts Unsanctioned "Office Olympics" — HR
                  Investigation Launched After Flonkerton Injury
                </td>
                <td className="px-5 py-4" data-id="element-879">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-880">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-881" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-882">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-883">
                  Jan 12, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-884">
                  Dunder Mifflin Expands Regional Operations
                </td>
                <td className="px-5 py-4" data-id="element-885">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-886">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-887" />
                    Positive
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-888">
        <div className="p-5 border-b border-gray-200" data-id="element-889">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-890">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-891">
          <table className="w-full text-sm text-left" data-id="element-892">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-893">
              <tr data-id="element-894">
                <th className="px-5 py-3 font-medium" data-id="element-895">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-896">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-897">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-898"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-899">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-900">
                <td className="px-5 py-3 text-indigo-600" data-id="element-901">ENERVATE INC.</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-902">Ultimate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-903">US</td>
                <td className="px-5 py-3" data-id="element-904">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-905">
                    Monitored
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-906">
                <td className="px-5 py-3 text-indigo-600" data-id="element-907">SABRE CORPORATION</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-908">Immediate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-909">US</td>
                <td className="px-5 py-3" data-id="element-910">
                  <PlusCircle className="w-5 h-5 text-indigo-500 cursor-pointer hover:text-indigo-700 transition-colors" data-id="element-911" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-912">
        <div className="p-5 border-b border-gray-200" data-id="element-913">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-914">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-915">
          <table className="w-full text-sm text-left" data-id="element-916">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-917">
              <tr data-id="element-918">
                <th className="px-5 py-3 font-medium" data-id="element-919">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-920">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-921">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-922">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-923">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-924">
                <td className="px-5 py-3 text-gray-900" data-id="element-925">
                  DUNDER MIFFLIN SCRANTON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-926">
                  Headquarters / Branch
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-927">
                  1725 Slough Ave, Scranton, PA 18503
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-928">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-929">
                <td className="px-5 py-3 text-gray-900" data-id="element-930">
                  DUNDER MIFFLIN AKRON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-931">Branch Office</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-932">
                  400 Market St, Akron, OH 44308
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-933">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} data-id="element-934" />}
    </div>;
}